/**
 * 姓名脱敏
 * @param {string} name - 原始姓名
 * @returns {string} 脱敏后姓名
 */
export function maskName(name: string) {
  if (!name || typeof name !== 'string') return '';
  const str = name.trim();
  const len = str.length;

  if (len === 1) {
    // 单字名
    return str;
  } else if (len === 2) {
    // 两字名：第一个字 + *
    return str[0] + '*';
  } else {
    // 三字及以上：首字 + N个* + 最后一字
    const star = '*'.repeat(len - 2);
    return str[0] + star + str.slice(-1);
  }
}
